import nextID from "@/commons/nextID";
import AfValidationProvider from "@/components/inputs/AfValidationProvider";

export default {
    components: {AfValidationProvider},
    model: {
        prop: 'value',
        event: 'input'
    },
    props: {
        id: {
            default() {
                return nextID();
            }
        },
        prefix: {
            default: ''
        },
        name: {},
        label: {},
        placeholder: {},
        value: {},
        rules: {
            default() {
                return {};
            }
        },
        mode: {
            default: 'aggressive'
        },
        tip: {},
        disableValidation: {
            default: false
        },
        validationLabel: {
            default: null
        },
        busy: {
            default: false
        },
    },
    computed: {
        vidComputed() {
            if (this.name) {
                return (this.prefix ? this.prefix + '.' : '') + this.name
            } else {
                return this.id
            }
        },

        labelComputed() {
            if (this.label !== undefined) return this.label
            if (this.name === undefined) return ''
            let name = this.name.split('.').pop()
            return this.$config(`lang.fields.${name}`, name)
        },
        placeholderComputed() {
            return this.placeholder !== undefined ? this.placeholder : this.labelComputed
        },
        localValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        inputId() {
            return this.vidComputed.replace(/\./g, '_')
        },
        inputName() {
            let name = this.vidComputed
            return name.split('.').reduce((acc, value, index) => {
                acc = acc + (index === 0 ? value : '[' + value + ']');
                return acc
            }, '')
        }
    },
    methods: {
        getValidationState({dirty, validated, valid = null}) {
            //if (this.rules === null || this.rules === undefined) return null
            return this.$validation.getValidationState({dirty, validated, valid});
        },
    }
}
